module.exports = __webpack_public_path__ + "img/icon_patent.423872f5.png";